import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { ResponseData, ResponsePaging } from "../../nest-responses";
import { ResponseAttFaceListingDto, RequestConfigFaceRecognizeBaseDto, RequestGetBasePhotoDto, RequestGetMyRequestDto, RequestProcessApproveDto, ResponseGetBasePhotoDto, ResponseGetMyRequestDto, ResponseGetNeedApprovalDto } from "../dto/attendance-face.dto";
import { RequestPagingDto } from "../dto/base.dto";

@Injectable()
export class AttendancesFaceApi {
  private readonly service: string = '';
  private readonly model: string = 'attendancesFace';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: { empId: string }, queryParams: RequestPagingDto) {
    const method: string = 'POST';
    const func: string = 'listing';
    const params: any = payload;
    const urlParams: any = queryParams;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseAttFaceListingDto>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public configFaceRecognizeBase(payload: RequestConfigFaceRecognizeBaseDto) {
    const method: string = 'POST';
    const func: string = 'configFaceRecognizeBase';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public getBasePhoto(payload: RequestGetBasePhotoDto) {
    const method: string = 'POST';
    const func: string = 'getBasePhoto';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetBasePhotoDto>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public getMyRequest(payload: RequestGetMyRequestDto) {
    const method: string = 'POST';
    const func: string = 'getMyRequest';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetMyRequestDto>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public getNeedApproval(payload: RequestPagingDto) {
    const method: string = 'GET';
    const func: string = 'getNeedApproval';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetNeedApprovalDto>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public processApprove(payload: RequestProcessApproveDto[]) {
    const method: string = 'POST';
    const func: string = 'processApprove';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  } 

  urlUploadFaceRecognize() {
    const method: string = 'POST';
    const func: string = 'uploadFaceRecognize';
    const params: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, {}, this.model);
    return url;
}


} 


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance-face.api.ts